import React from "react";

export default function CSS_Editor() {
  return (
    <div className="tutorial-page">
      <h1>CSS Editor</h1>
      <p>This is the CSS Editor tutorial page.</p>
    </div>
  );
}
